import React from "react";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/modal/email.svg";
import { ReactComponent as PhoneIcon } from "../../../../assets/icons/supplier/phone.svg";

import { IClient } from "../../../../types/clients.type";
import { formatPhoneNumber } from "../../../../utils/fotmatPhoneNumber";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  client: IClient;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewClientForm: React.FC<Props> = (props) => {
  return (
    <div>
      {(props.client.email || props.client.phone) && (
        <div className={styles.form}>
          {props.client.email && (
            <ViewInput title="Пошта" isCopied value={props.client.email}>
              <EmailIcon />
            </ViewInput>
          )}
          {props.client.phone && (
            <ViewInput
              title="Номер телефону"
              value={formatPhoneNumber(props.client.phone)}
              isCopied
            >
              <PhoneIcon />
            </ViewInput>
          )}
          {/* 
          {props.client.note && (
            <ViewInput
              title="Примітка"
              value={props.client.note}
              isBig={true}
            />
          )} */}
        </div>
      )}
      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewClientForm;
